export default "<p>admin works!</p>\r\n"